<template>
  <VRow justify="start" no-gutters class="mb-6">
    <AccountSettingsInterviewForm
      :company="company"
    />
    <AccountSettingsAiProcessor v-if="hasHhIntegration" />
    <AccountSettingsNotifications />
  </VRow>
</template>

<script>
import { onMounted } from '@vue/composition-api';
import useCompany from '@/compositions/useCompany';
import useHHIntegration from '@/compositions/useHHIntegration';
import AccountSettingsInterviewForm from './AccountSettingsInterviewForm.vue';
import AccountSettingsAiProcessor from './AccountSettingsAiProcessor.vue';
import AccountSettingsNotifications from './AccountSettingsNotifications.vue';

export default {
  name: 'AccountSettings',
  components: {
    AccountSettingsInterviewForm,
    AccountSettingsNotifications,
    AccountSettingsAiProcessor,
  },
  setup() {
    const { company } = useCompany();
    const hhIntegration = useHHIntegration();

    onMounted(async () => {
      await hhIntegration.fetchIntegrationData();
    });

    return {
      company,
      hasHhIntegration: hhIntegration.isAuthorized,
    };
  },
};
</script>
